<div class="main-layout">
  <app-header (menuToggle)="onMobileMenuToggle()"> </app-header>

  <div class="main-layout__wrapper">
    <div
      class="main-layout__sidebar"
      [class.main-layout__sidebar--collapsed]="isSidebarCollapsed()"
    >
      <app-sidebar
        [items]="sidebarItems()"
        [isCollapsed]="isSidebarCollapsed()"
        (collapsedChange)="onSidebarCollapsedChange($event)"
      >
      </app-sidebar>
    </div>

    <main class="main-layout__content">
      <div class="main-layout__body">
        <router-outlet />
      </div>
    </main>
  </div>
</div>
